import styled from 'styled-components';

export const LinkWrapper = styled.div`
  background-color: whitesmoke;
  padding: 5px;
  border-radius: 6px;
`;
